export default "__VITE_ASSET__RPeQedA1__"